import _ from 'lodash'
import {
  getServicesQuery,
  createServiceMutation,
  deleteServiceMutation,
  updateServiceMutation,
  getServiceByIdQuery,
  getAllServiceTypesQuery
} from '~graphql/service.graphql'

export default {
  getAllServiceTypes({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'serviceTypes:get',
      modelName: 'serviceTypes',
      query: getAllServiceTypesQuery,
      resultPath: 'serviceTypes.nodes'
    })
  },
  getServices({ state, dispatch, commit }, { filter, offset, first, orderBy }) {
    commit('SET_ITEM', {
      state,
      item: [],
      modelName: 'services'
    })
    const defaultFilter = {
      id: {
        isNull: false
      } // used to allow empty filter
    }
    const mergedFilter = _.merge(filter, defaultFilter)

    return dispatch('getItems', {
      state,
      loader: 'services:get',
      modelName: 'services',
      query: getServicesQuery,
      resultPath: 'services.nodes',
      totalPath: 'services.totalCount',
      totalModelName: 'servicesCount',
      variables: {
        filter: mergedFilter,
        offset,
        first,
        orderBy
      }
    })
  },
  getServiceById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'services:get',
      addTo: ['services'],
      query: getServiceByIdQuery,
      resultPath: 'service'
    })
  },
  createService({ state, dispatch }, service) {
    return dispatch('createItem', {
      item: { service },
      state,
      loader: 'service:create',
      addTo: ['services'],
      mutation: createServiceMutation,
      resultPath: 'createService.service'
    })
  },
  updateService({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedService',
      addTo: ['services'],
      loader: 'service:update',
      mutation: updateServiceMutation,
      resultPath: 'updateService.service'
    })
  },
  deleteService({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedService',
      removeFrom: ['services'],
      loader: 'service:delete',
      mutation: deleteServiceMutation
    })
  },
  setSelectedService({ state, commit }, selectedService) {
    commit('SET_ITEM', {
      state,
      item: selectedService,
      modelName: 'selectedService'
    })
  }
}
